<app-add-favorite></app-add-favorite>
